import { render, staticRenderFns } from "./loanListDialog.vue?vue&type=template&id=bdffafda&scoped=true"
import script from "./loanListDialog.vue?vue&type=script&lang=js"
export * from "./loanListDialog.vue?vue&type=script&lang=js"
import style0 from "./loanListDialog.vue?vue&type=style&index=0&id=bdffafda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdffafda",
  null
  
)

export default component.exports